module.exports = __webpack_public_path__ + "img/sample_02.d974ccb1.jpg";